import { Skeleton } from '@mui/material';
import React from 'react';
import Styles from './EntityDrawer.scss';

const EntityDrawerAttributeSkeleton = (props) => {
    return (
        <React.Fragment>
            <Skeleton
                variant="rectangular"
                animation="wave"
                height={17}
                width={100}
            />
            <div className={Styles.entityDrawerAttributesContainer}>
                <div className={Styles.attributeRow}>
                    <div className={Styles.attributeRowKey}>
                        <Skeleton
                            variant="rectangular"
                            animation="wave"
                            height={12}
                            width={35}
                        />
                    </div>

                    <div className={Styles.attributeRowValue}>
                        <Skeleton
                            variant="rectangular"
                            animation="wave"
                            height={12}
                            width={65}
                        />
                    </div>
                </div>
                <div className={Styles.attributeRow}>
                    <div className={Styles.attributeRowKey}>
                        <Skeleton
                            variant="rectangular"
                            animation="wave"
                            height={12}
                            width={55}
                        />
                    </div>

                    <div className={Styles.attributeRowValue}>
                        <Skeleton
                            variant="rectangular"
                            animation="wave"
                            height={12}
                            width={115}
                        />
                    </div>
                </div>
                <div className={Styles.attributeRow}>
                    <div className={Styles.attributeRowKey}>
                        <Skeleton
                            variant="rectangular"
                            animation="wave"
                            height={12}
                            width={35}
                        />
                    </div>

                    <div className={Styles.attributeRowValue}>
                        <Skeleton
                            variant="rectangular"
                            animation="wave"
                            height={12}
                            width={65}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default EntityDrawerAttributeSkeleton;
